import keymirror from 'keymirror';

const AppModalTypes = keymirror({
  applicationError: null,
  deleteOptionWithLogic: null,
  removeBlockWithLogic: null,
  scaleChangeItemCount: null,
  scaleChangeStartFromZero: null,
  changeSurveyStatus: null,
  insertBodyBackgroundImage: null,
  insertHeaderBackgroundImage: null,
  insertHeaderLogoImage: null,
  insertQuestionOptionImage: null,
  insertQuestionOptionImagePreview: null,
  clearSection: null,
  resetActiveSurveySettings: null,
  deleteImage: null,
  deleteSurvey: null,
  archiveSurvey: null, 
  overwriteCustomStyles: null,
  headerBackgroundImagePreview: null,
  headerLogoImagePreview: null,
  editorImagePreview: null,
  useSurveyTemplate: null,
  confirmUseSurveyTemplate: null,
  deleteTemplate: null,
  changeEditSurveyStatus: null,
  insertHeaderLogoImageLink: null,
  setSharedHeader: null,
});

export default AppModalTypes;
